import { boot } from 'quasar/wrappers'
import lottie from 'lottie-web'

export default boot(({ app }) => {
  app.config.globalProperties.$lottie = lottie
})

export { lottie }
